import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Grid,
  Box,
  FormControl,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Button,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory } from 'react-router-dom'
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Palette from "../../Palette";
import Provinces from "../../util/ProvinceData";
import Select from 'react-select'
import Cities from "../../util/CityData";
import MomentUtils from '@date-io/moment';
import Upload from "../../models/Upload";
import moment from "moment";
import Member from "../../models/Member";
import Swal from "sweetalert2";
import Alert from "../../components/Alert";

const randomizeMail = () => Math.floor(Math.random() * (1000 - 100 + 1)) + 100;

const payloadTemplate = {
  "full_name": "Komune",
  "mitra_entity": "FOUNDATION",
  "mitra_policy_number": "1201201929",
  "address_street": "Tangerang",
  "address_region": "Banten",
  "address_locality": null,
  "address_postal": "15810",
  "phone_number": "8212918212912",
  "email_address": `robbysoftdev+${randomizeMail()}1@gmail.com`,
  "website_url": "https://www.google.com/",
  "password": "password",
  "password_confirmation": "password",
  "mitra_year_founded": "2020-07-09T17:00:00.000Z",
  "mitra_services": {
    "penerjemahan": true,
    "interpreting": true,
    "pelatihan": false,
    "penyusunan": false,
    "lainnya": false
  },
  "about_me": "Ini adalah deskripsi tentang mitra swasta kami.",
  "mitra_vision": "Mantappu",
  "mitra_mission": "Mantappu",
  "mitra_resource_translator": "12",
  "mitra_resource_intrepater": "30",
  "mitra_resource_has_referance": true,
  "mitra_resource_reference": [
    {
      "full_name": "Dora",
      "hpi_id": "8219201023"
    },
    {
      "full_name": "Dore",
      "hpi_id": "81929129912"
    }
  ],
  "mitra_attachment_document": {
    "salinan_akta": [
      {
        "name": "Salinan AKTA.docx",
        "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1760933739711-HPI - Prosedur Pendaftaran Mitra Swasta Terdaftar.docx"
      }
    ],
    "salinan_nib_siup_tpd": [
      {
        "name": "Salinan NIB/SIUP/TDP.pdf",
        "url": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1760934451484-NIB.pdf"
      }
    ],
    "profile": [],
    "profession": [],
  },
  "mitra_pic_name": "Dorian",
  "mitra_pic_position": "Developer",
  "mitra_pic_address": null,
  "mitra_signature_date": "2025-10-08T05:32:00.000Z",
  "mitra_signature_image": "https://wellsource.sgp1.digitaloceanspaces.com/sihapei_media/uploads/unknown/1760933637364-91f00353814ad474a23d6104bf0ffec2.jpg"
}
export default function MitraFormRegisterPage() {
  const history = useHistory()
  const [errorMsg, setErrorMsg] = useState(null);
  const [errors, setErrors] = useState({});
  const [fullName, setFullName] = useState(null); //Nama Perusahaan/Lembaga
  const [mitraEntity, setMitraEntity] = useState(null); // PT/CV/FOUNDATION/CORPORATION
  const [mitraPolicyNumber, setMitraPolicyNumber] = useState(null); //Nomor Induk Berusaha (NIB)/Izin Usaha
  const [addressStreet, setAddressStreet] = useState(null); //Alamat Kantor
  const [addressRegion, setAddressRegion] = useState(null); //Provinsi
  const [addressLocality, setAddressLocality] = useState(null); //Kota/Kabupaten
  const [addressPostal, setAddressPostal] = useState(null);  //Kode Pos
  const [phoneNumber, setPhoneNumber] = useState(null); //No Telepon
  const [emailAddress, setEmailAddress] = useState(null); //Email
  const [websiteURL, setWebsiteURL] = useState(null); //Website Resmi

  const [mitraYearFounded, setMitraYearFounded] = useState(null); //Tahun Berdiri
  const [mitraServices, setMitraServices] = useState({ //Bidang Layanan Bahasa Utama
    penerjemahan: false,
    interpreting: false,
    pelatihan: false,
    penyusunan: false,
    lainnya: false,
  });
  const [aboutMe, setAboutMe] = useState(null); //Tentang Mitra Swasta
  const [mitraVision, setMitraVision] = useState(null); //Visi
  const [mitraMission, setMitraMission] = useState(null); //Misi

  const [mitraPortfolio, setMitraPortfolio] = useState([]); //Portofolio layanan utama/klien (file upload)
  const [mitraPortfolioUploading, setMitraPortfolioUploading] = useState(false); //Upload progress state
  const [mitraResourceTranslator, setMitraResourceTranslator] = useState(null); //Jumlah tenaga penerjemah
  const [mitraResourceIntrepater, setMitraResourcIntrepater] = useState(null);//Jumlah tenaga juru bahasa
  const [mitraResourceHasReferance, setMitraResourceHasReferance] = useState(false);// //Apakah ada penerjemah/juru bahasa Anggota HPI di dalam tim?
  const [mitraResourceReference, setMitraResourceReference] = useState([]); //when mitraResourceHasReferance true, this field is required
  const [mitraAttachmentDocument, setMitraAttachmentDocument] = useState({
    salinan_akta: [],
    salinan_nib_siup_tpd: [],
    profile: [],
    profession: [],
  }); //mitra_attachment_document
  const [mitraAttachmentChecked, setMitraAttachmentChecked] = useState({
    salinan_akta: false,
    salinan_nib_siup_tpd: false,
    profile: false,
    profession: false,
  });
  const [mitraAttachmentUploading, setMitraAttachmentUploading] = useState({
    salinan_akta: false,
    salinan_nib_siup_tpd: false,
    profile: false,
    profession: false,
  });
  const [mitraPicName, setMitraPicName] = useState(null); //mitra_pic_name
  const [mitraPicPosition, setMitraPicPosition] = useState(null); //mitra_pic_position
  const [mitraPicAddress, setMitraPicAddress] = useState(null); //mitra_pic_address
  const [mitraSignatureDate, setMitraSignatureDate] = useState(null);
  const [mitraSignatureImage, setMitraSignatureImage] = useState(null); //tanda tangan stempel
  const [password, setPassword] = useState(null); //password
  const [passwordConfirmation, setPasswordConfirmation] = useState(null); //password confirmation
  const [agreedToTerms, setAgreedToTerms] = useState(false); //terms agreement checkbox
  const [termsDialogOpen, setTermsDialogOpen] = useState(false); //terms dialog state
  const provinceOptionList = Provinces.map((value) => ({ label: value.province, value: value.province_id }))
  const cityOptionList = addressRegion
    ? Cities.filter((city) => city.province === addressRegion).map((city) => ({
      label: city.city_name,
      value: city.city_id
    }))
    : [];


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const isLoggedIn = localStorage.getItem('user')

    if (isLoggedIn) {
      history.replace('/')
    }
  }, [history])

  const handleServiceChange = (e) => {
    setMitraServices({ ...mitraServices, [e.target.name]: e.target.checked });
  };

  const handleAttachmentUpload = async (fieldName, files) => {
    setMitraAttachmentUploading({ ...mitraAttachmentUploading, [fieldName]: true });
    try {
      const uploadedFiles = [];
      for (let file of files) {
        const formData = new FormData();
        formData.append('upload', file, file.name);
        const result = await modelUpload.uploadImage(formData);
        if (result?.location) {
          uploadedFiles.push({
            name: file.name,
            url: result.location
          });
        }
      }
      setMitraAttachmentDocument({
        ...mitraAttachmentDocument,
        [fieldName]: [...mitraAttachmentDocument[fieldName], ...uploadedFiles]
      });

      if (errors.mitraAttachmentDocument) {
        setErrors({ ...errors, mitraAttachmentDocument: null });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setMitraAttachmentUploading({ ...mitraAttachmentUploading, [fieldName]: false });
    }
  };

  const handleAttachmentRemove = (fieldName, index) => {
    const newFiles = mitraAttachmentDocument[fieldName].filter((_, i) => i !== index);
    setMitraAttachmentDocument({
      ...mitraAttachmentDocument,
      [fieldName]: newFiles
    });
  };

  const modelUpload = new Upload()
  const modelMember = new Member()

  const handleSignatureUpload = async function (image) {
    try {
      const formData = new FormData()
      formData.append('upload', image, image.name)
      const result = await modelUpload.uploadImage(formData)
      setMitraSignatureImage(result?.location)

    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const validateForm = () => {
    const newErrors = {};
    if (!fullName || fullName.trim() === '') {
      newErrors.fullName = 'Nama Perusahaan/Lembaga wajib diisi';
    }

    if (!mitraEntity) {
      newErrors.mitraEntity = 'Bentuk Badan Usaha wajib dipilih';
    }

    if (!mitraPolicyNumber || mitraPolicyNumber.trim() === '') {
      newErrors.mitraPolicyNumber = 'NIB/Izin Usaha wajib diisi';
    }

    if (!addressStreet || addressStreet.trim() === '') {
      newErrors.addressStreet = 'Alamat Kantor wajib diisi';
    }

    if (!addressRegion) {
      newErrors.addressRegion = 'Provinsi wajib dipilih';
    }

    if (!addressLocality) {
      newErrors.addressLocality = 'Kota/Kabupaten wajib dipilih';
    }

    if (!phoneNumber || phoneNumber.trim() === '') {
      newErrors.phoneNumber = 'No Telepon wajib diisi';
    }

    if (!addressPostal || addressPostal.trim() === '') {
      newErrors.addressPostal = 'Kode Pos wajib diisi';
    }

    if (!emailAddress || emailAddress.trim() === '') {
      newErrors.emailAddress = 'Email wajib diisi';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
      newErrors.emailAddress = 'Format email tidak valid';
    }

    if (websiteURL && websiteURL.trim() !== '') {
      const urlPattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
      if (!urlPattern.test(websiteURL)) {
        newErrors.websiteURL = 'Format URL tidak valid';
      }
    }

    if (!aboutMe || aboutMe.trim() === '') {
      newErrors.aboutMe = 'Tentang Mitra Swasta Terdaftar wajib diisi';
    }

    if (!password || password.trim() === '') {
      newErrors.password = 'Password wajib diisi';
    } else if (password.length < 6) {
      newErrors.password = 'Password minimal 6 karakter';
    }

    if (!passwordConfirmation || passwordConfirmation.trim() === '') {
      newErrors.passwordConfirmation = 'Konfirmasi Password wajib diisi';
    } else if (password !== passwordConfirmation) {
      newErrors.passwordConfirmation = 'Password tidak cocok';
    }

    const hasAtLeastOneDocument = Object.values(mitraAttachmentDocument).some(
      (docArray) => docArray && docArray.length > 0
    );
    if (!hasAtLeastOneDocument) {
      newErrors.mitraAttachmentDocument = 'Minimal satu dokumen harus diunggah';
    }

    if (!mitraPicName || mitraPicName.trim() === '') {
      newErrors.mitraPicName = 'Nama Penanggung Jawab wajib diisi';
    }

    if (!mitraPicPosition || mitraPicPosition.trim() === '') {
      newErrors.mitraPicPosition = 'Jabatan wajib diisi';
    }

    if (!mitraSignatureImage) {
      newErrors.mitraSignatureImage = 'Tanda tangan & Stempel Perusahaan wajib diunggah';
    }

    if (mitraResourceHasReferance) {
      if (!mitraResourceReference || mitraResourceReference.length === 0) {
        newErrors.mitraResourceReference = 'Minimal satu Anggota HPI harus ditambahkan';
      } else {
        const hasEmptyFields = mitraResourceReference.some(
          (ref) => !ref.full_name || ref.full_name.trim() === '' || !ref.hpi_id || ref.hpi_id.trim() === ''
        );
        if (hasEmptyFields) {
          newErrors.mitraResourceReference = 'Nama dan Nomor Anggota HPI wajib diisi';
        }
      }
    }

    setErrors(newErrors);
    return { isValid: Object.keys(newErrors).length === 0, errors: newErrors };
  };

  const handleSubmit = async (e) => {
    try {
      setErrors({});
      setErrorMsg(null);

      const validation = validateForm();
      if (!validation.isValid) {
        const fieldNames = {
          fullName: 'Nama Perusahaan/Lembaga',
          mitraEntity: 'Bentuk Badan Usaha',
          mitraPolicyNumber: 'NIB/Izin Usaha',
          addressStreet: 'Alamat Kantor',
          addressRegion: 'Provinsi',
          addressLocality: 'Kota/Kabupaten',
          phoneNumber: 'No Telepon',
          addressPostal: 'Kode Pos',
          emailAddress: 'Email',
          websiteURL: 'Situs Web Resmi',
          aboutMe: 'Tentang Mitra Swasta Terdaftar',
          password: 'Kata Sandi',
          passwordConfirmation: 'Konfirmasi Kata Sandi',
          mitraAttachmentDocument: 'Dokumen',
          mitraPicName: 'Nama Penanggung Jawab',
          mitraPicPosition: 'Jabatan',
          mitraSignatureImage: 'Tanda tangan & Stempel Perusahaan',
          mitraResourceReference: 'Anggota HPI'
        };

        const errorFields = Object.keys(validation.errors).map(key => fieldNames[key] || key);
        setErrorMsg(`Mohon lengkapi kolom berikut: ${errorFields.join(', ')}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const confirmResult = await Swal.fire({
        title: 'Konfirmasi',
        text: 'Apakah Anda yakin ingin mendaftar sebagai Mitra Swasta Terdaftar?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#0000FF',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Daftar',
        cancelButtonText: 'Batal',
      });

      if (!confirmResult.isConfirmed) {
        return;
      }

      const payload = {
        full_name: fullName,
        mitra_entity: mitraEntity,
        mitra_policy_number: mitraPolicyNumber,
        address_street: addressStreet,
        address_region: addressRegion,
        address_locality: addressLocality,
        address_postal: addressPostal,
        phone_number: phoneNumber,
        email: emailAddress,
        website_url: websiteURL,
        password: password,
        password_confirmation: passwordConfirmation,
        mitra_year_founded: mitraYearFounded,
        mitra_services: mitraServices,
        about_me: aboutMe,
        mitra_vision: mitraVision,
        mitra_mission: mitraMission,
        mitra_attachment_portofolio: mitraPortfolio,
        mitra_resource_translator: mitraResourceTranslator,
        mitra_resource_intrepater: mitraResourceIntrepater,
        mitra_resource_has_referance: mitraResourceHasReferance,
        mitra_resource_reference: mitraResourceReference,
        mitra_attachment_document: mitraAttachmentDocument,
        mitra_pic_name: mitraPicName,
        mitra_pic_position: mitraPicPosition,
        mitra_pic_address: mitraPicAddress,
        // mitra_signature_date: mitraSignatureDate,
        mitra_signature_image: mitraSignatureImage,
      }

      Swal.fire({
        title: 'Mengirim Data...',
        text: 'Mohon tunggu sebentar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const result = await modelMember.registerMitra(payload)
      const paymentLink = result?.payment_link


      await Swal.fire({
        title: 'Pendaftaran Berhasil',
        text: 'Pendaftaran berhasil! Anda akan diarahkan ke halaman pembayaran.',
        icon: 'success',
        confirmButtonColor: '#0000FF',
        confirmButtonText: 'OK',
      })

      window.location.href = paymentLink
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Terjadi Kesalahan',
        text: e?.error_message || e?.message || 'Gagal mengirim data. Silakan coba lagi.',
      })
      console.error(e)
    } finally {

    }
  }

  //use effect to load initial data for dummy
  useEffect(() => {
    const loadData = async () => {
      try {
        setFullName(payloadTemplate.full_name)
        setMitraEntity(payloadTemplate.mitra_entity)
        setMitraPolicyNumber(payloadTemplate.mitra_policy_number)
        setAddressStreet(payloadTemplate.address_street)
        setAddressRegion(payloadTemplate.address_region)
        setAddressLocality(payloadTemplate.address_locality)
        setAddressPostal(payloadTemplate.address_postal)
        setPhoneNumber(payloadTemplate.phone_number)
        setEmailAddress(payloadTemplate.email_address)
        setWebsiteURL(payloadTemplate.website_url)
        setPassword(payloadTemplate.password)
        setPasswordConfirmation(payloadTemplate.password_confirmation)
        setMitraYearFounded(payloadTemplate.mitra_year_founded)
        setMitraServices(payloadTemplate.mitra_services)
        setAboutMe(payloadTemplate.about_me)
        setMitraVision(payloadTemplate.mitra_vision)
        setMitraMission(payloadTemplate.mitra_mission)
        setMitraPortfolio(payloadTemplate.mitra_portfolio || [])
        setMitraResourceTranslator(payloadTemplate.mitra_resource_translator)
        setMitraResourcIntrepater(payloadTemplate.mitra_resource_intrepater)
        setMitraResourceHasReferance(payloadTemplate.mitra_resource_has_referance)
        setMitraResourceReference(payloadTemplate.mitra_resource_reference)
        setMitraAttachmentDocument(payloadTemplate.mitra_attachment_document)
        //set all mitraAttachmentChecked to true if there is document
        const newAttachmentChecked = { ...mitraAttachmentChecked }
        Object.keys(payloadTemplate.mitra_attachment_document).forEach((key) => {
          if (payloadTemplate.mitra_attachment_document[key].length > 0) {
            newAttachmentChecked[key] = true
          }
        })
        setMitraAttachmentChecked(newAttachmentChecked)

        setMitraPicName(payloadTemplate.mitra_pic_name)
        setMitraPicPosition(payloadTemplate.mitra_pic_position)
        setMitraPicAddress(payloadTemplate.mitra_pic_address)
        setMitraSignatureDate(payloadTemplate.mitra_signature_date)
        setMitraSignatureImage(payloadTemplate.mitra_signature_image)

      } catch (e) {
        console.error(e)
      } finally {

      }
    }
    // loadData()

  }, [])

  return (
    <>



      <Container maxWidth="lg" sx={{ px: 5, py: 5, fontFamily: 'Signika, sans-serif' }} >
        {/* Judul */}
        <Box textAlign="center" mb={6} >
          <Typography
            style={{ color: Palette.PRIMARY, fontWeight: "bold", fontFamily: 'Signika, sans-serif' }}
            variant="h4"
            fontWeight="bold"
            color={Palette.PRIMARY}
            gutterBottom
          >
            Himpunan Penerjemah Indonesia
          </Typography>
          <Typography variant="h6" fontWeight={500} color="textPrimary" sx={{ fontFamily: 'Signika, sans-serif' }}>
            Formulir Pendaftaran Mitra Swasta Terdaftar
          </Typography>
        </Box>
        {
          errorMsg && <Alert
            type="error"
            className="mx-0"
            errorMsg={errorMsg}
            textStyle={{ fontSize: 16, fontWeight: 500 }}
          />
        }
        {/* Form Data Perusahaan */}
        <Box sx={{
          backgroundColor: '#fff',
          borderRadius: 2,
          p: 4,
          mb: 4,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <Box mb={3}>
            <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Data Perusahaan atau Lembaga
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Nama Perusahaan/Lembaga */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Nama Perusahaan/Lembaga <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input Nama Perusahaan / Lembaga"
                  variant="outlined"
                  value={fullName || ''}
                  onChange={(e) => {
                    setFullName(e.target.value);
                    if (errors.fullName) {
                      setErrors({ ...errors, fullName: null });
                    }
                  }}
                  error={!!errors.fullName}
                  helperText={errors.fullName}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Bentuk Badan Usaha & NIB */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Bentuk Badan Usaha <span style={{ color: '#999', fontSize: '0.8rem', fontFamily: 'Signika, sans-serif' }}>(PT/CV/Yayasan/Koperasi)</span> <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  select
                  placeholder="Pilih Bentuk Badan Usaha"
                  variant="outlined"
                  value={mitraEntity || ''}
                  onChange={(e) => {
                    setMitraEntity(e.target.value);
                    if (errors.mitraEntity) {
                      setErrors({ ...errors, mitraEntity: null });
                    }
                  }}
                  error={!!errors.mitraEntity}
                  helperText={errors.mitraEntity}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  SelectProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                >
                  {
                    Member.MITRA_SWASTA_ENTITY_OPTIONS.map((option) => {
                      return (
                        <MenuItem key={option.value} value={option.value} sx={{ fontFamily: 'Signika, sans-serif' }}>
                          {option.label}
                        </MenuItem>
                      )
                    })
                  }

                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Nomor Induk Berusaha (NIB)/Izin Usaha <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input NIB"
                  variant="outlined"
                  value={mitraPolicyNumber || ''}
                  onChange={(e) => {
                    setMitraPolicyNumber(e.target.value);
                    if (errors.mitraPolicyNumber) {
                      setErrors({ ...errors, mitraPolicyNumber: null });
                    }
                  }}
                  error={!!errors.mitraPolicyNumber}
                  helperText={errors.mitraPolicyNumber}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Alamat Kantor */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Alamat Kantor <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Input Alamat"
                  variant="outlined"
                  value={addressStreet || ''}
                  onChange={(e) => {
                    setAddressStreet(e.target.value);
                    if (errors.addressStreet) {
                      setErrors({ ...errors, addressStreet: null });
                    }
                  }}
                  error={!!errors.addressStreet}
                  helperText={errors.addressStreet}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Provinsi */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Provinsi <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Select
                  options={provinceOptionList}
                  value={provinceOptionList.find(opt => opt.label === addressRegion) || null}
                  onChange={(selectedOption) => {
                    setAddressRegion(selectedOption ? selectedOption.label : null);
                    setAddressLocality(null);
                    if (errors.addressRegion) {
                      setErrors({ ...errors, addressRegion: null });
                    }
                  }}
                  placeholder="Pilih Provinsi"
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      fontFamily: 'Signika, sans-serif',
                      minHeight: '56px',
                      fontSize: '16px',
                      borderColor: errors.addressRegion ? '#d32f2f' : base.borderColor,
                    }),
                    menu: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    option: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    placeholder: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    singleValue: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                  }}
                />
                {errors.addressRegion && (
                  <Typography variant="caption" sx={{ color: '#d32f2f', fontFamily: 'Signika, sans-serif', marginLeft: '14px', marginTop: '3px', fontSize: '0.75rem' }}>
                    {errors.addressRegion}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Kota/Kabupaten */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Kota/Kabupaten <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Select
                  options={cityOptionList}
                  value={cityOptionList.find(opt => opt.label === addressLocality) || null}
                  onChange={(selectedOption) => {
                    setAddressLocality(selectedOption ? selectedOption.label : null);
                    if (errors.addressLocality) {
                      setErrors({ ...errors, addressLocality: null });
                    }
                  }}
                  placeholder="Pilih Kota/Kabupaten"
                  isClearable
                  isDisabled={!addressRegion}
                  styles={{
                    control: (base) => ({
                      ...base,
                      fontFamily: 'Signika, sans-serif',
                      minHeight: '56px',
                      fontSize: '16px',
                      borderColor: errors.addressLocality ? '#d32f2f' : base.borderColor,
                    }),
                    menu: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    option: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    placeholder: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                    singleValue: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                  }}
                />
                {errors.addressLocality && (
                  <Typography variant="caption" sx={{ color: '#d32f2f', fontFamily: 'Signika, sans-serif', marginLeft: '14px', marginTop: '3px', fontSize: '0.75rem' }}>
                    {errors.addressLocality}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* No Telepon & Kode Pos */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  No Telepon <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input No Telepon"
                  variant="outlined"
                  value={phoneNumber || ''}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                    if (errors.phoneNumber) {
                      setErrors({ ...errors, phoneNumber: null });
                    }
                  }}
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Kode Pos <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input Kode Pos"
                  variant="outlined"
                  value={addressPostal || ''}
                  onChange={(e) => {
                    setAddressPostal(e.target.value);
                    if (errors.addressPostal) {
                      setErrors({ ...errors, addressPostal: null });
                    }
                  }}
                  error={!!errors.addressPostal}
                  helperText={errors.addressPostal}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Email & Website */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Email <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  type="email"
                  placeholder="Input Email"
                  variant="outlined"
                  value={emailAddress || ''}
                  onChange={(e) => {
                    setEmailAddress(e.target.value);
                    if (errors.emailAddress) {
                      setErrors({ ...errors, emailAddress: null });
                    }
                  }}
                  error={!!errors.emailAddress}
                  helperText={errors.emailAddress}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Situs Web Resmi
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input Situs Web Resmi"
                  variant="outlined"
                  value={websiteURL || ''}
                  onChange={(e) => {
                    setWebsiteURL(e.target.value);
                    if (errors.websiteURL) {
                      setErrors({ ...errors, websiteURL: null });
                    }
                  }}
                  error={!!errors.websiteURL}
                  helperText={errors.websiteURL}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Password */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Kata Sandi <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  placeholder="Input Kata Sandi"
                  variant="outlined"
                  value={password || ''}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (errors.password) {
                      setErrors({ ...errors, password: null });
                    }
                  }}
                  error={!!errors.password}
                  helperText={errors.password}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Password Confirmation */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Konfirmasi Kata Sandi<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  placeholder="Konfirmasi Kata Sandi"
                  variant="outlined"
                  value={passwordConfirmation || ''}
                  onChange={(e) => {
                    setPasswordConfirmation(e.target.value);
                    if (errors.passwordConfirmation) {
                      setErrors({ ...errors, passwordConfirmation: null });
                    }
                  }}
                  error={!!errors.passwordConfirmation}
                  helperText={errors.passwordConfirmation}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {/* Profil Usaha */}
        <Box sx={{
          backgroundColor: '#fff',
          borderRadius: 2,
          p: 4,
          mb: 4,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <Box mb={3}>
            <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Profil Usaha
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Tahun Berdiri */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem' }}>
                  Tahun Berdiri
                </Typography>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    views={["year"]}
                    value={mitraYearFounded}
                    onChange={(date) => setMitraYearFounded(date)}
                    inputVariant="outlined"
                    fullWidth
                    maxDate={moment()}
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Grid>

            {/* Bidang Layanan Bahasa Utama */}
            <Grid item xs={12}>
              <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                Bidang Layanan Bahasa Utama
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraServices.penerjemahan}
                      onChange={handleServiceChange}
                      name="penerjemahan"
                      color="primary"
                    />
                  }
                  label="Penerjemahan Tulis"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraServices.interpreting}
                      onChange={handleServiceChange}
                      name="interpreting"
                      color="primary"
                    />
                  }
                  label="Penjurubahasaan (Interpreting)"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraServices.pelatihan}
                      onChange={handleServiceChange}
                      name="pelatihan"
                      color="primary"
                    />
                  }
                  label="Pelatihan Bahasa"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraServices.penyusunan}
                      onChange={handleServiceChange}
                      name="penyusunan"
                      color="primary"
                    />
                  }
                  label="Penyusunan / Penyuntingan Dokumen"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraServices.lainnya}
                      onChange={handleServiceChange}
                      name="lainnya"
                      color="primary"
                    />
                  }
                  label="Layanan Bahasa Lainnya"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormGroup>
            </Grid>

            {/* About Visi & Misi */}

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Tentang Mitra Swasta Terdaftar <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={6}
                  placeholder="Masukkan deskripsi tentang Mitra Swasta Terdaftar"
                  variant="outlined"
                  value={aboutMe || ''}
                  onChange={(e) => {
                    setAboutMe(e.target.value);
                    if (errors.aboutMe) {
                      setErrors({ ...errors, aboutMe: null });
                    }
                  }}
                  error={!!errors.aboutMe}
                  helperText={errors.aboutMe}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Visi
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Input Visi"
                  variant="outlined"
                  value={mitraVision || ''}
                  onChange={(e) => setMitraVision(e.target.value)}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Misi
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Input Misi"
                  variant="outlined"
                  value={mitraMission || ''}
                  onChange={(e) => setMitraMission(e.target.value)}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>

            {/* Portofolio */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Portofolio layanan utama/klien{" "}
                  <span style={{ fontStyle: "italic", color: "#999", fontSize: '0.8rem', fontFamily: 'Signika, sans-serif' }}>
                    (opsional)
                  </span>
                </Typography>
                <Box>
                  <input
                    id="upload-portfolio"
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    style={{ display: 'none' }}
                    onChange={async (e) => {
                      if (e.target.files.length > 0) {
                        setMitraPortfolioUploading(true);
                        try {
                          const uploadedFiles = [];
                          for (let file of Array.from(e.target.files)) {
                            const formData = new FormData();
                            formData.append('upload', file, file.name);
                            const result = await modelUpload.uploadImage(formData);
                            if (result?.location) {
                              uploadedFiles.push({
                                name: file.name,
                                url: result.location
                              });
                            }
                          }
                          setMitraPortfolio([...(mitraPortfolio || []), ...uploadedFiles]);
                        } catch (e) {
                          console.error(e);
                        } finally {
                          setMitraPortfolioUploading(false);
                        }
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById('upload-portfolio').click()}
                    disabled={mitraPortfolioUploading}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                    startIcon={mitraPortfolioUploading ? <CircularProgress size={20} /> : null}
                  >
                    {mitraPortfolioUploading ? 'Mengunggah...' : 'Unggah File'}
                  </Button>
                  {mitraPortfolio && mitraPortfolio.length > 0 && (
                    <Box mt={1}>
                      {mitraPortfolio.map((file, index) => (
                        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const newFiles = mitraPortfolio.filter((_, i) => i !== index);
                              setMitraPortfolio(newFiles);
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {/* Sumber Daya Manusia */}
        <Box sx={{
          backgroundColor: '#fff',
          borderRadius: 2,
          p: 4,
          mb: 4,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <Box mb={3}>
            <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Sumber Daya Manusia
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* 1. Jumlah tenaga tetap */}
            <Grid item xs={12}>
              <Box display="flex" alignItems="center">
                <Typography sx={{ minWidth: 320, fontFamily: 'Signika, sans-serif' }}>
                  1. Jumlah tenaga penerjemah :
                </Typography>
                <TextField
                  type="number"
                  size="small"
                  sx={{ width: 80, mx: 2 }}
                  placeholder="..."
                  value={mitraResourceTranslator || ''}
                  onChange={(e) => setMitraResourceTranslator(e.target.value)}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
                <Typography sx={{ fontFamily: 'Signika, sans-serif' }}>Orang</Typography>
              </Box>
            </Grid>

            {/* 2. Jumlah tenaga lepas */}
            <Grid item xs={12}>
              <Box display="flex" alignItems="center">
                <Typography sx={{ minWidth: 320, fontFamily: 'Signika, sans-serif' }}>
                  2. Jumlah tenaga juru bahasa :
                </Typography>
                <TextField
                  type="number"
                  size="small"
                  sx={{ width: 80, mx: 2 }}
                  placeholder="..."
                  value={mitraResourceIntrepater || ''}
                  onChange={(e) => setMitraResourcIntrepater(e.target.value)}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
                <Typography sx={{ fontFamily: 'Signika, sans-serif' }}>Orang</Typography>
              </Box>
            </Grid>

            {/* 3. Ada anggota HPI? */}
            <Grid item xs={12}>
              <Typography mb={1} sx={{ fontFamily: 'Signika, sans-serif' }}>
                3. Apakah ada penerjemah/juru bahasa Anggota HPI di dalam tim?
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={mitraResourceHasReferance}
                      onChange={(e) => {
                        setMitraResourceHasReferance(e.target.checked);
                        if (errors.mitraResourceReference) {
                          setErrors({ ...errors, mitraResourceReference: null });
                        }
                      }}
                      name="ya"
                      color="primary"
                    />
                  }
                  label="Ya (sebutkan nama dan nomor anggota HPI)"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!mitraResourceHasReferance}
                      onChange={(e) => {
                        setMitraResourceHasReferance(!e.target.checked);
                        if (errors.mitraResourceReference) {
                          setErrors({ ...errors, mitraResourceReference: null });
                        }
                      }}
                      name="tidak"
                      color="primary"
                    />
                  }
                  label="Tidak"
                  sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormGroup>

              {mitraResourceHasReferance && (
                <Box mt={2}>
                  {mitraResourceReference.map((ref, index) => (
                    <Box style={{ display: 'flex', gap: 10 }} key={index} mb={2} alignItems="center">
                      <TextField
                        fullWidth
                        placeholder="Nama Anggota HPI"
                        variant="outlined"
                        size="small"
                        value={ref.full_name || ''}
                        onChange={(e) => {
                          const newRefs = [...mitraResourceReference];
                          newRefs[index].full_name = e.target.value;
                          setMitraResourceReference(newRefs);
                          if (errors.mitraResourceReference) {
                            setErrors({ ...errors, mitraResourceReference: null });
                          }
                        }}
                        error={!!errors.mitraResourceReference}
                        InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                      />
                      <TextField
                        fullWidth
                        placeholder="Nomor Anggota HPI"
                        variant="outlined"
                        size="small"
                        value={ref.hpi_id || ''}
                        onChange={(e) => {
                          const newRefs = [...mitraResourceReference];
                          newRefs[index].hpi_id = e.target.value;
                          setMitraResourceReference(newRefs);
                          if (errors.mitraResourceReference) {
                            setErrors({ ...errors, mitraResourceReference: null });
                          }
                        }}
                        error={!!errors.mitraResourceReference}
                        InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                      />
                      <IconButton
                        color="secondary"
                        onClick={() => {
                          const newRefs = mitraResourceReference.filter((_, i) => i !== index);
                          setMitraResourceReference(newRefs);
                          if (errors.mitraResourceReference) {
                            setErrors({ ...errors, mitraResourceReference: null });
                          }
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  ))}
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setMitraResourceReference([...mitraResourceReference, { full_name: '', hpi_id: '' }]);
                      if (errors.mitraResourceReference) {
                        setErrors({ ...errors, mitraResourceReference: null });
                      }
                    }}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                  >
                    + Tambah Anggota HPI
                  </Button>
                </Box>
              )}
              {errors.mitraResourceReference && (
                <Typography variant="caption" sx={{ color: '#d32f2f', fontFamily: 'Signika, sans-serif', marginLeft: '14px', marginTop: '8px', fontSize: '0.75rem', display: 'block' }}>
                  {errors.mitraResourceReference}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>

        {/* Dokumen yang Dilampirkan */}
        <Box sx={{
          backgroundColor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 4,
          mb: 4,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <Box mb={3}>
            <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Dokumen yang Dilampirkan <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Signika, sans-serif', mt: 1 }}>
              Minimal satu dokumen harus diunggah
            </Typography>
            {errors.mitraAttachmentDocument && (
              <Typography variant="body2" sx={{ color: '#d32f2f', fontFamily: 'Signika, sans-serif', mt: 1 }}>
                {errors.mitraAttachmentDocument}
              </Typography>
            )}
          </Box>
          <Grid container spacing={3}>
            {/* Salinan Akta */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mitraAttachmentChecked.salinan_akta}
                    onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, salinan_akta: e.target.checked })}
                    color="primary"
                  />
                }
                label="Salinan akta pendirian perusahaan/badan usaha"
                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
              />
              {mitraAttachmentChecked.salinan_akta && (
                <Box ml={4} mt={1}>
                  <input
                    id="upload-salinan-akta"
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        handleAttachmentUpload('salinan_akta', Array.from(e.target.files));
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById('upload-salinan-akta').click()}
                    disabled={mitraAttachmentUploading.salinan_akta}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                    startIcon={mitraAttachmentUploading.salinan_akta ? <CircularProgress size={20} /> : null}
                  >
                    {mitraAttachmentUploading.salinan_akta ? 'Mengunggah...' : 'Unggah File'}
                  </Button>
                  {mitraAttachmentDocument.salinan_akta.length > 0 && (
                    <Box mt={1}>
                      {mitraAttachmentDocument.salinan_akta.map((file, index) => (
                        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                          <IconButton size="small" onClick={() => handleAttachmentRemove('salinan_akta', index)}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Grid>

            {/* Salinan NIB/SIUP/TDP */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mitraAttachmentChecked.salinan_nib_siup_tpd}
                    onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, salinan_nib_siup_tpd: e.target.checked })}
                    color="primary"
                  />
                }
                label="Salinan NIB/SIUP/TDP"
                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
              />
              {mitraAttachmentChecked.salinan_nib_siup_tpd && (
                <Box ml={4} mt={1}>
                  <input
                    id="upload-salinan-nib"
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        handleAttachmentUpload('salinan_nib_siup_tpd', Array.from(e.target.files));
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById('upload-salinan-nib').click()}
                    disabled={mitraAttachmentUploading.salinan_nib_siup_tpd}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                    startIcon={mitraAttachmentUploading.salinan_nib_siup_tpd ? <CircularProgress size={20} /> : null}
                  >
                    {mitraAttachmentUploading.salinan_nib_siup_tpd ? 'Mengunggah...' : 'Unggah File'}
                  </Button>
                  {mitraAttachmentDocument.salinan_nib_siup_tpd.length > 0 && (
                    <Box mt={1}>
                      {mitraAttachmentDocument.salinan_nib_siup_tpd.map((file, index) => (
                        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                          <IconButton size="small" onClick={() => handleAttachmentRemove('salinan_nib_siup_tpd', index)}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Grid>

            {/* Profil Perusahaan */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mitraAttachmentChecked.profile}
                    onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, profile: e.target.checked })}
                    color="primary"
                  />
                }
                label="Profil perusahaan (brosur/portofolio singkat)"
                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
              />
              {mitraAttachmentChecked.profile && (
                <Box ml={4} mt={1}>
                  <input
                    id="upload-profile"
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        handleAttachmentUpload('profile', Array.from(e.target.files));
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById('upload-profile').click()}
                    disabled={mitraAttachmentUploading.profile}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                    startIcon={mitraAttachmentUploading.profile ? <CircularProgress size={20} /> : null}
                  >
                    {mitraAttachmentUploading.profile ? 'Mengunggah...' : 'Unggah File'}
                  </Button>
                  {mitraAttachmentDocument.profile.length > 0 && (
                    <Box mt={1}>
                      {mitraAttachmentDocument.profile.map((file, index) => (
                        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                          <IconButton size="small" onClick={() => handleAttachmentRemove('profile', index)}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Grid>

            {/* Daftar Penerjemah */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mitraAttachmentChecked.profession}
                    onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, profession: e.target.checked })}
                    color="primary"
                  />
                }
                label="Daftar penerjemah/juru bahasa mitra/tetap"
                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
              />
              {mitraAttachmentChecked.profession && (
                <Box ml={4} mt={1}>
                  <input
                    id="upload-profession"
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        handleAttachmentUpload('profession', Array.from(e.target.files));
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById('upload-profession').click()}
                    disabled={mitraAttachmentUploading.profession}
                    sx={{ fontFamily: 'Signika, sans-serif' }}
                    startIcon={mitraAttachmentUploading.profession ? <CircularProgress size={20} /> : null}
                  >
                    {mitraAttachmentUploading.profession ? 'Mengunggah...' : 'Unggah File'}
                  </Button>
                  {mitraAttachmentDocument.profession.length > 0 && (
                    <Box mt={1}>
                      {mitraAttachmentDocument.profession.map((file, index) => (
                        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                          <IconButton size="small" onClick={() => handleAttachmentRemove('profession', index)}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              )}
            </Grid>

          </Grid>
        </Box>

        {/* Pernyataan */}
        <Box sx={{
          backgroundColor: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          p: 4,
          mb: 4,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <Box
            gap={2}
            mb={3}
            spacing={5}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Pernyataan
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Signika, sans-serif' }}>
              Dengan ini kami menyatakan bahwa data yang diberikan adalah benar dan
              dapat dipertanggungjawabkan. Kami bersedia mematuhi Anggaran
              Dasar/Anggaran Rumah Tangga HPI, Kode Etik dan Kode Perilaku Himpunan
              Penerjemah Indonesia, serta ketentuan kerja sama yang berlaku bagi
              Mitra Swasta Terdaftar.
            </Typography>
          </Box>


          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Nama Penanggung Jawab <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input Nama Penanggung Jawab"
                  variant="outlined"
                  value={mitraPicName || ''}
                  onChange={(e) => {
                    setMitraPicName(e.target.value);
                    if (errors.mitraPicName) {
                      setErrors({ ...errors, mitraPicName: null });
                    }
                  }}
                  error={!!errors.mitraPicName}
                  helperText={errors.mitraPicName}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                  Jabatan <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Input Jabatan"
                  variant="outlined"
                  value={mitraPicPosition || ''}
                  onChange={(e) => {
                    setMitraPicPosition(e.target.value);
                    if (errors.mitraPicPosition) {
                      setErrors({ ...errors, mitraPicPosition: null });
                    }
                  }}
                  error={!!errors.mitraPicPosition}
                  helperText={errors.mitraPicPosition}
                  InputProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                  FormHelperTextProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                />
              </FormControl>
            </Grid>
            {/* <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem' }}>
                  Tanggal
                </Typography>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    value={mitraSignatureDate}
                    onChange={(date) => setMitraSignatureDate(date)}
                    inputVariant="outlined"
                    fullWidth
                    format="DD/MM/YYYY"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Grid> */}
            <Grid item xs={12}>
              <Typography variant="body2" fontWeight={500} mb={0.5} sx={{ fontSize: '0.875rem', fontFamily: 'Signika, sans-serif' }}>
                Tanda tangan & Stempel Perusahaan <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Box
                sx={{
                  border: errors.mitraSignatureImage ? "1px dashed #d32f2f" : "1px dashed gray",
                  borderRadius: 1,
                  minHeight: 120,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "gray",
                  fontStyle: "italic",
                  cursor: "pointer",
                  position: "relative",
                  "&:hover": {
                    borderColor: "primary.main",
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                  },
                }}
                onClick={() => document.getElementById('signature-upload').click()}
              >
                <input
                  id="signature-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      handleSignatureUpload(file);
                      if (errors.mitraSignatureImage) {
                        setErrors({ ...errors, mitraSignatureImage: null });
                      }
                    }
                  }}
                />
                {mitraSignatureImage && mitraSignatureImage.length > 0 ? (
                  <Box sx={{ textAlign: 'center', p: 2, position: 'relative' }}>
                    <IconButton
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 8,
                        backgroundColor: 'white',
                        '&:hover': { backgroundColor: '#f5f5f5' },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setMitraSignatureImage(null);
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    <img
                      src={mitraSignatureImage}
                      alt="Signature preview"
                      style={{ maxHeight: '100px', maxWidth: '100%' }}
                    />
                  </Box>
                ) : (
                  <Typography sx={{ fontFamily: 'Signika, sans-serif' }}>
                    Klik untuk upload tanda tangan & stempel
                  </Typography>
                )}
              </Box>
              {errors.mitraSignatureImage && (
                <Typography variant="caption" sx={{ color: '#d32f2f', fontFamily: 'Signika, sans-serif', marginLeft: '14px', marginTop: '3px', fontSize: '0.75rem' }}>
                  {errors.mitraSignatureImage}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>

        {/* Checkbox Persetujuan */}
        <Box mt={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreedToTerms}
                onChange={(e) => setAgreedToTerms(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>
                Saya menyetujui{' '}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    setTermsDialogOpen(true);
                  }}
                  style={{
                    color: '#0000FF',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  syarat ketentuan Mitra Swasta HPI
                </span>
              </Typography>
            }
          />
        </Box>

        {/* Dialog Syarat dan Ketentuan */}
        <Dialog
          open={termsDialogOpen}
          onClose={() => setTermsDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ fontFamily: 'Signika, sans-serif', fontWeight: 'bold' }}>
            Syarat dan Ketentuan Mitra Swasta HPI
          </DialogTitle>
          <DialogContent>
            <Typography variant="subtitle1" paragraph sx={{ fontFamily: 'Signika, sans-serif', ml: 2, fontWeight: 'bold' }}>
              Pembatalan dan Pengembalian Dana
            </Typography>
            <Typography variant="body2" paragraph sx={{ fontFamily: 'Signika, sans-serif', ml: 2 }}>
              Pengembalian biaya pendaftaran akan dikenakan sebesar Rp.100.000,- (seratus ribu rupiah) untuk biaya administrasi apabila Mitra Swasta Terdaftar membatalkan pendaftarannya sebelum proses verifikasi selesai. Setelah proses verifikasi selesai, biaya pendaftaran tidak dapat dikembalikan.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setTermsDialogOpen(false)}
              style={{
                color: '#0000FF',
                fontFamily: 'Signika, sans-serif',
                fontWeight: 'bold',
              }}
            >
              Tutup
            </Button>
          </DialogActions>
        </Dialog>

        {/* Tombol Daftar */}
        <Box mt={4}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            disabled={!agreedToTerms}
            style={{
              py: 4,
              borderRadius: 2,
              fontSize: "1.125rem",
              color: "#FFFFFF",
              fontWeight: "bold",
              fontFamily: 'Signika, sans-serif',
              backgroundColor: agreedToTerms ? '#0000FF' : '#C4C4C4',
              '&:hover': {
                backgroundColor: agreedToTerms ? '#0000FF' : '#C4C4C4',
              }
            }}
            onClick={handleSubmit}
          >
            Daftar
          </Button>
        </Box>
      </Container>
    </>

  );
}